import type { SVGProps } from "react";
export interface StampIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StampIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StampIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.582 5.734c0-1.448-1.163-2.609-2.582-2.609S9.417 4.286 9.417 5.734c0 .495.137.954.371 1.346.3.502.52 1.045.683 1.565l.066.235c.281 1.172-.083 2.271-.794 3.062-.742.824-1.856 1.317-3.038 1.317h-.528c-1.27 0-2.25 1.163-2.018 2.447l.212 1.17h15.258l.212-1.17c.232-1.284-.748-2.447-2.018-2.447h-.528c-1.182 0-2.296-.493-3.036-1.317-.758-.844-1.12-2.04-.725-3.297l.131-.39c.144-.393.322-.79.543-1.166l.004-.009.083-.15c.183-.358.287-.763.287-1.196m2.25 0c0 .908-.25 1.76-.685 2.49l.001.002c-.14.24-.262.51-.367.798l-.1.294c-.134.428-.028.809.25 1.12.297.33.793.57 1.364.57h.528c2.693 0 4.71 2.454 4.232 5.098l-.3 1.656a1.656 1.656 0 0 1-1.627 1.363H3.872c-.756 0-1.401-.51-1.596-1.218l-.032-.145-.299-1.656c-.477-2.644 1.539-5.097 4.232-5.097h.528c.57 0 1.068-.242 1.366-.573.245-.272.357-.598.292-.96l-.04-.16a5 5 0 0 0-.466-1.082 4.86 4.86 0 0 1-.69-2.5C7.167 3.058 9.324.875 12 .875s4.832 2.183 4.832 4.859M20 20.875l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H4a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
